import { z } from 'zod';

export const TEMPLATE_TYPE_SCHEMA = z.enum(['FRANCO', 'MERCHANT', 'STANDARD']);

export type TEMPLATE_TYPES = z.infer<typeof TEMPLATE_TYPE_SCHEMA>;

export const TEMPLATE_GROUP_TITLE_SCHEMA = z.enum([
    'BULK_GOODS_DELIVERY',
    'RECYCLING_BULK_GOODS_DELIVERY',
    'ASPHALT_DELIVERY',
    'CONCRETE_DELIVERY',
    'NON_HAZARDOUS_WASTE_RECYCLING',
    'HAZARDOUS_WASTE_RECYCLING',
    'NON_HAZARDOUS_WASTE_DISPOSAL',
    'HAZARDOUS_WASTE_DISPOSAL',
    'NON_HAZARDOUS_WASTE_RECYCLING_MATERIAL',
    'HAZARDOUS_WASTE_RECYCLING_MATERIAL',
    'NON_HAZARDOUS_WASTE_DISPOSAL_MATERIAL',
    'HAZARDOUS_WASTE_DISPOSAL_MATERIAL',
    'BULK_GOODS',
    'RECYCLING_BULK_GOODS',
    'ASPHALT',
    'CONCRETE',
    'TRANSPORT_PER_HOUR',
    'TRANSPORT_PER_TON',
    'TRANSPORT',
    'SERVICE_ANALYSIS',
    'SERVICE_ACCOMPANYING_DOCUMENT',
    'SERVICE_WAITING_TIME',
    'SERVICE_TOLL',
    'SERVICE_MATERIAL',
    'SERVICE_TRANSPORT',
    'MOCK_TEMPLATE',
]);

export type TEMPLATE_GROUP_TITLE = z.infer<typeof TEMPLATE_GROUP_TITLE_SCHEMA>;

export const PRODUCT_GROUP_TEMPLATE_TITLE_SCHEMA = z.enum([
    'BULK_GOODS_DELIVERY',
    'RECYCLING_BULK_GOODS_DELIVERY',
    'ASPHALT_DELIVERY',
    'CONCRETE_DELIVERY',
    'NON_HAZARDOUS_WASTE_RECYCLING',
    'HAZARDOUS_WASTE_RECYCLING',
    'NON_HAZARDOUS_WASTE_DISPOSAL',
    'HAZARDOUS_WASTE_DISPOSAL',
    'NON_HAZARDOUS_WASTE_RECYCLING_MATERIAL',
    'HAZARDOUS_WASTE_RECYCLING_MATERIAL',
    'NON_HAZARDOUS_WASTE_DISPOSAL_MATERIAL',
    'HAZARDOUS_WASTE_DISPOSAL_MATERIAL',
    'BULK_GOODS',
    'RECYCLING_BULK_GOODS',
    'ASPHALT',
    'CONCRETE',
    'NON_HAZARDOUS_WASTE',
    'HAZARDOUS_WASTE',
    'BILLED_PER_HOUR',
    'BILLED_PER_TON',
    'FLAT_RATE',
    'SERVICE_ANALYSIS',
    'SERVICE_ACCOMPANYING_DOCUMENT',
    'SERVICE_TOLL',
    'SERVICE_WAITING_TIME',
    'SERVICE_MATERIAL',
    'SERVICE_TRANSPORT',
]);

export const TEMPLATE_GROUP_DESCRIPTION_SCHEMA = z.enum([
    'FRANCO_DESCRIPTION',
    'MERCHANT_DESCRIPTION',
    'TRANSPORT_DESCRIPTION',
    'RECYCLING_DESCRIPTION',
    'DISPOSAL_DESCRIPTION',
]);

export type TEMPLATE_GROUP_DESCRIPTION = z.infer<typeof TEMPLATE_GROUP_DESCRIPTION_SCHEMA>;
